export const iconFontAwesomeHumanitarianUsersBetweenLines = (
	<i className="fa-solid fa-users-between-lines"></i>
);
